import { FC } from "react"
import { Button } from "@unlimint/admin-ui-kit"
import { Form } from "formik"

import { InputField } from "view/components/formik/InputField"

import * as S from "./styled"

type TCreateThemeModalProps = {
  isSubmitting: boolean
  onClose(): void
}

export const CreateThemeModal: FC<TCreateThemeModalProps> = ({
  isSubmitting,
  onClose,
}) => {
  return (
    <Form>
      <S.Wrapp>
        <S.Title>Create customization</S.Title>

        <div>
          <S.Label>Customization name (styleName)</S.Label>
          <InputField name="name" disabled={isSubmitting} />

          <S.Info>
            <S.InfoText>
              This theme name will be used as the styleName parameter in the
              widget configuration.
            </S.InfoText>

            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10ZM11 7C11 7.55228 10.5523 8 10 8C9.44772 8 9 7.55228 9 7C9 6.44772 9.44772 6 10 6C10.5523 6 11 6.44772 11 7ZM8.75 10C8.33579 10 8 10.3358 8 10.75C8 11.1642 8.33579 11.5 8.75 11.5H9.5V13.25C9.5 13.6642 9.83579 14 10.25 14C10.6642 14 11 13.6642 11 13.25V10.75C11 10.3358 10.6642 10 10.25 10H8.75Z"
                fill="#9A9FA0"
              />
            </svg>
          </S.Info>
        </div>

        <S.BtnsBlock>
          <Button
            size="small"
            color="secondary"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button size="small" type="submit" disabled={isSubmitting}>
            Create
          </Button>
        </S.BtnsBlock>
      </S.Wrapp>
    </Form>
  )
}
